import axios from "axios";

const url = require("../../client_config/config").url;

const state = {
    items: [],
    dialog: false,
    loading: false,
};

const getters = {
isLoading: (state) => state.loading,
};

const actions = {
    async addItem({ commit }, data) {
        try {
          const response = await axios.post(`${url}/calendar/`, data);
          commit("ADD_ITEM", response.data);
          return response.data;
        } catch (error) {
          return error.response;
        }
      },
};

const mutations = {
    ADD_ITEM(state, data) {
      state.items.push(data);
    },
  
    SET_DIALOG(state, data) {
      state.dialog = data;
    },
  
    SET_LOADING(state, data) {
      state.loading = data;
    },
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
  